import { defineMessages } from "react-intl"
import { SelectOption } from "../../common/types/select"



export namespace  CREDIT_MEMO_STATUS {
    export const AVAILABLE = "available"
    export const PARTIALLY_APPLIED = "partially-applied"
    export const FULLY_APPLIED = "fully-applied"
    export const PENDING = "pending"


}

export type CREDIT_MEMO_STATUS = typeof CREDIT_MEMO_STATUS[keyof typeof CREDIT_MEMO_STATUS]

export const generateOptions = (intlService) : SelectOption<string>[] => {
    const messages = defineMessages({
        [CREDIT_MEMO_STATUS.AVAILABLE] : {
            id: "credit_memo.status_selection.status_available",
            defaultMessage: "Available",
        },
        [CREDIT_MEMO_STATUS.PARTIALLY_APPLIED]: {
            id: "credit_memo.status_selection.status_partially_applied",
            defaultMessage: "Partially applied",
        },
        [CREDIT_MEMO_STATUS.FULLY_APPLIED]: {
            id: "credit_memo.status_selection.status_fully_applied",
            defaultMessage: "Fully applied",
        },
        [CREDIT_MEMO_STATUS.PENDING]: {
            id: "credit_memo.status_selection.status_pending",
            defaultMessage: "Pending",
        },
    })
    
    return [
        {
            value: CREDIT_MEMO_STATUS.AVAILABLE,
            label: intlService.formatMessage(messages[CREDIT_MEMO_STATUS.AVAILABLE])
        },
        {
            value: CREDIT_MEMO_STATUS.PARTIALLY_APPLIED,
            label: intlService.formatMessage(messages[CREDIT_MEMO_STATUS.PARTIALLY_APPLIED])
        },
        {
            value: CREDIT_MEMO_STATUS.FULLY_APPLIED,
            label: intlService.formatMessage(messages[CREDIT_MEMO_STATUS.FULLY_APPLIED])
        },
        {
            value: CREDIT_MEMO_STATUS.PENDING,
            label: intlService.formatMessage(messages[CREDIT_MEMO_STATUS.PENDING])
        },

    ]
}


// WEBPACK FOOTER //
// ./src/invoice/credit-memo/CreditMemoStatus.ts